import React from 'react'

export default function Jobs() {
  return (
    <>
      <section className="s4">
        <div className="s44">
            <div className="left1">
                <div className="left">
                    <div className="up">
                        <p><i className="fa-solid fa-bookmark"></i> My Jobs</p>
                        <p><i className="fa-solid fa-bell"></i> Job Alerts</p>
                        <p><i className="fa-solid fa-money-bill"></i> Salary</p>
                        <p><i className="fa-solid fa-clipboard-check"></i> Skill Assessments</p>
                        <p><i className="fa-solid fa-file"></i> Interview Prep</p>
                        <p><i className="fa-solid fa-file"></i> Resume Builder</p>
                        <p><i className="fa-brands fa-youtube"></i> Job Seeker Guidence</p>
                        <p><i className="fa-solid fa-gear"></i> Application Settings</p>
                    </div>
                    <div className="down">
                        <p><i className="fa-solid fa-pen-to-square"></i> Post a free job</p>
                    </div>
                </div>
            </div>
            <div className="right">
                <div className="up">
                    <div className="d1">
                        <div className="b1">
                            <h3>Recent job searches</h3>
                            <p className="clear">Clear</p>
                        </div>
                        <div className="b2">
                            <p><b>graduate student <span>(39 new)</span> </b></p>
                            <p className="small"> Mumbai, India . Fll-time</p>
                        </div>
                        <hr style={{color: "rgba(153, 153, 153, 0.518)"}} />
                        <div className="b2">
                            <p><b>graduate student <span>(5 new)</span> </b></p>
                            <p className="small"> India . Part-time</p>
                        </div>
                    </div>
                    <div className="d2">
                        <div className="img">
                            <img src="/images/profileimage.jpeg" alt="User Profile" />
                        </div>
                        <div className="tryprem">
                            <p>Try Premium to see jobs where you would be a top applicant</p>
                            <p className="small">Milions of members use Premium</p>
                            <button>Try Free for 1 Month</button>
                        </div>
                    </div>
                    <div className="d3">
                        <div className="b1">
                            <img src="https://media-exp1.licdn.com/dms/image/C560BAQFqUr6Koz6FnA/company-logo_100_100/0/1519903924399?e=1657152000&v=beta&t=c-EATZB6XTOiDGUuMRWp5H8w-cnpa739isnX-hgWwfI" alt="img" />
                            <div className="b11">
                                <h3>Seniour Angular Developer</h3>
                                <p>Epitome Technologies Ltd.</p>
                                <p>Chandigarh, India (On-site</p>
                                <p className="time"> <span>2d ago</span> . <i className="fa-brands fa-linkedin"></i> Easy Apply</p>
                            </div>
                        </div>
                        <div className="b1">
                            <img src="https://media-exp1.licdn.com/dms/image/C560BAQFqUr6Koz6FnA/company-logo_100_100/0/1519903924399?e=1657152000&v=beta&t=c-EATZB6XTOiDGUuMRWp5H8w-cnpa739isnX-hgWwfI" alt="img" />
                            <div className="b11">
                                <h3>Seniour Angular Developer</h3>
                                <p>Epitome Technologies Ltd.</p>
                                <p>Chandigarh, India (On-site</p>
                                <p className="time"> <span>2d ago</span> . <i className="fa-brands fa-linkedin"></i> Easy Apply</p>
                            </div>
                        </div>
                        <div className="b1">
                            <img src="https://media-exp1.licdn.com/dms/image/C560BAQFqUr6Koz6FnA/company-logo_100_100/0/1519903924399?e=1657152000&v=beta&t=c-EATZB6XTOiDGUuMRWp5H8w-cnpa739isnX-hgWwfI" alt="img" />
                            <div className="b11">
                                <h3>Seniour Angular Developer</h3>
                                <p>Epitome Technologies Ltd.</p>
                                <p>Chandigarh, India (On-site</p>
                                <p className="time"> <span>2d ago</span> . <i className="fa-brands fa-linkedin"></i> Easy Apply</p>
                            </div>
                        </div>
                        <div className="b1">
                            <img src="https://media-exp1.licdn.com/dms/image/C560BAQFqUr6Koz6FnA/company-logo_100_100/0/1519903924399?e=1657152000&v=beta&t=c-EATZB6XTOiDGUuMRWp5H8w-cnpa739isnX-hgWwfI" alt="img" />
                            <div className="b11">
                                <h3>Seniour Angular Developer</h3>
                                <p>Epitome Technologies Ltd.</p>
                                <p>Chandigarh, India (On-site</p>
                                <p className="time"> <span>2d ago</span> . <i className="fa-brands fa-linkedin"></i> Easy Apply</p>
                            </div>
                        </div>
                        <div className="b1">
                            <img src="https://media-exp1.licdn.com/dms/image/C560BAQFqUr6Koz6FnA/company-logo_100_100/0/1519903924399?e=1657152000&v=beta&t=c-EATZB6XTOiDGUuMRWp5H8w-cnpa739isnX-hgWwfI" alt="img" />
                            <div className="b11">
                                <h3>Seniour Angular Developer</h3>
                                <p>Epitome Technologies Ltd.</p>
                                <p>Chandigarh, India (On-site</p>
                                <p className="time"> <span>2d ago</span> . <i className="fa-brands fa-linkedin"></i> Easy Apply</p>
                            </div>
                        </div>
                        <div className="b1">
                            <img src="https://media-exp1.licdn.com/dms/image/C560BAQFqUr6Koz6FnA/company-logo_100_100/0/1519903924399?e=1657152000&v=beta&t=c-EATZB6XTOiDGUuMRWp5H8w-cnpa739isnX-hgWwfI" alt="img" />
                            <div className="b11">
                                <h3>Seniour Angular Developer</h3>
                                <p>Epitome Technologies Ltd.</p>
                                <p>Chandigarh, India (On-site</p>
                                <p className="time"> <span>2d ago</span> . <i className="fa-brands fa-linkedin"></i> Easy Apply</p>
                            </div>
                        </div>
                        <div className="b1">
                            <img src="https://media-exp1.licdn.com/dms/image/C560BAQFqUr6Koz6FnA/company-logo_100_100/0/1519903924399?e=1657152000&v=beta&t=c-EATZB6XTOiDGUuMRWp5H8w-cnpa739isnX-hgWwfI" alt="img" />
                            <div className="b11">
                                <h3>Seniour Angular Developer</h3>
                                <p>Epitome Technologies Ltd.</p>
                                <p>Chandigarh, India (On-site</p>
                                <p className="time"> <span>2d ago</span> . <i className="fa-brands fa-linkedin"></i> Easy Apply</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="down">
                    <div className="d1">
                        <div className="b1">
                            <h3>Job seeker guidance</h3>
                            <p className="small font-big">Recommended based on your activity</p>
                        </div>
                        <div className="b2">
                            <p>I want to improve my resume</p>
                            <img src="/images/jobspage.gif" alt="img" />
                        </div>
                        <div className="b3">
                            <p>Explore our curated guide of expert-led courses, such as how to improve your resume and grow your network, to help you land your next opportunity.</p>
                            <p className="showmore small font-big mu-4">Show more <i className="fa-solid fa-arrow-right-long"></i></p>
                        </div>
                    </div>
                    <div className="right2 mu-4 d2">
                        <footer>
                            <div className="foot">
                                <a href="/">About</a> &nbsp; &nbsp;
                                <a href="/">Accessibility</a> &nbsp; &nbsp;
                                <a href="/">Help Center</a> &nbsp;
                                <a href="/">Privacy & terms <i className="fa-solid fa-chevron-down"></i></a> &nbsp; &nbsp;
                                <a href="/">Ad Choices</a> &nbsp; 
                                <a href="/">Advertising</a> &nbsp; 
                                <a href="/">Business Services <i className="fa-solid fa-chevron-down"></i></a> &nbsp; &nbsp;
                                <a href="/">Get the Linkedin app</a> &nbsp; &nbsp;
                                <a href="/">More</a> &nbsp; &nbsp;
                            </div>
                            <h5>Linked <i className="fa-brands fa-linkedin"></i> LinkedIn Corporation &#x24B8; 2022</h5>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
